






































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from '@/components/Layout/Header.vue';
import SideMenu from '@/components/Layout/SideMenu.vue';
import PokerTable from '@/components/PokerTable.vue';
import PlayingCardPicker from '@/components/PlayingCardPicker.vue';
import VotingResults from '@/components/VotingResults.vue';
import { Card } from '../models/Card';
import { ConnectionManager } from '../services/ConnectionManager';
import { RoomCommunicationService } from '../services/RoomCommunicationService';
import { GameState, RoomDataStore } from '../services/RoomDataStore';
import { RoomModalService } from '../services/RoomModalService';
import { StorageService } from '../services/StorageService';
import { SoundEffectsPlayer } from '../services/SoundEffectsPlayer';
import { PlayerRole } from '../models/PlayerRole';

@Component({
  components: {
    Header,
    SideMenu,
    PokerTable,
    PlayingCardPicker,
    VotingResults
  }
})
export default class Room extends Vue {
  @Prop({ required: true }) roomId!: string;

  GameState = GameState;
  showSideMenu = false;

  roomStore: RoomDataStore = new RoomDataStore(new StorageService());
  private roomService: RoomCommunicationService;
  private roomModalService: RoomModalService;

  constructor() {
    super();
    this.roomService = new RoomCommunicationService(
      this.roomStore,
      new ConnectionManager(),
      new SoundEffectsPlayer()
    );
    this.roomModalService = new RoomModalService(this);
  }

  selectCardChange(card: Card | null) {
    if (card !== null && this.roomStore.selectedCard !== card) {
      this.roomStore.selectCard(card as Card);
      this.roomService.updatePlayerCardSelected();
    } else {
      this.roomStore.clearCard();
      this.roomService.updatePlayerCardCleared();
    }
  }

  showCards() {
    this.roomService.showCards();
    this.roomStore.setGameState(GameState.results);
  }

  resetGame() {
    this.roomStore.resetGame();
    this.roomService.resetGame();
  }

  showUpdateDetails() {
    this.roomModalService.showPlayerDetailsForm(this.roomStore.myDetails).then(playerDetails => {
      this.roomStore.setPlayerDetails(playerDetails);
      this.roomService.updatePlayerDetails(playerDetails);
    });
  }

  openSideMenu() {
    this.showSideMenu = true;
  }

  closeSideMenu() {
    this.showSideMenu = false;
  }

  get playersCount() {
    return this.roomStore.players.filter(m => m.role === PlayerRole.Player).length;
  }
  get viewersCount() {
    return this.roomStore.players.filter(m => m.role === PlayerRole.Viewer).length;
  }

  get atLeastOneVote() {
    return this.roomStore.players.some(p => p.role === PlayerRole.Player && p.cardSelected);
  }

  get isPlayer() {
    return this.roomStore.myDetails?.role === PlayerRole.Player;
  }

  created() {
    this.roomService.connectRoom(this.roomId).then(() => {
      if (!this.roomStore.myDetails)
        this.roomModalService.showPlayerDetailsForm(null, false).then(playerDetails => {
          this.roomStore.setPlayerDetails(playerDetails);
          this.roomService.joinRoom();
        });
      else this.roomService.joinRoom();
    });
  }
}
